var maps = [];
$(document).ready(function() {
    $('.photo, .wp-block-gallery a').magnificPopup({
        type: 'image',
        closeOnContentClick: false,
		closeBtnInside: false,
		mainClass: 'mfp-with-zoom mfp-img-mobile',
		image: {
			verticalFit: true,
			titleSrc: function(item) {
				return "";
			}
		},
		gallery: {
			enabled: true
		},
		zoom: {
			enabled: true,
			duration: 300, // don't foget to change the duration also in CSS
			opener: function(element) {
				return element.find('img');
			}
		}
    });

    $(".jsLink").click(function(){
         window.location=$(this).find("a").attr("href");
         return false;
    });

    $('.btn-iframe').magnificPopup({
        type: 'iframe',
        gallery: {
            enabled: false
        }
    });

    $("a.modal-btn").click(function(){
        $('#'+$(this).attr('data-target')).addClass('active');
        $('#'+$(this).attr('data-target')).addClass('active');
        //$('#'+$(this).attr('data-target')).css('height', $(document).height());
        $('body').addClass('locked');
    });

    $("#modal a.close").click(function(){
        $('#modal').removeClass('active');
        $('body').removeClass('locked');
    });
    $("#head .mobileNav").click(function(){
        if($('#head .nav').hasClass('active')){
            $("#head .mobileNav i").removeClass('icon-close').addClass('icon-menu');
            $('#head .nav').removeClass('active');
            $('body').removeClass('locked');
        }else{
            $("#head .mobileNav i").addClass('icon-close').removeClass('icon-menu');
            $('#head .nav').addClass('active');
            $('body').addClass('locked');
        }
    });

    var owlDetailGalery = $('.detail-home');
    owlDetailGalery.owlCarousel({
        loop: false,
        margin: 0,
        nav: false,
        dots: false,
        items:1,
        autoplay:false,
        autoplay:true,
        autoplayTimeout:4000,
        autoplayHoverPause:true,
        animateOut: 'fadeOut'
    });

    var owlDetailGalery = $('.detail-galery');
    owlDetailGalery.owlCarousel({
        loop: false,
        margin: 25,
        nav: false,
        dots: false,
        items:1,
        autoplay:false,
        autoplay:true,
        autoplayTimeout:4000,
        autoplayHoverPause:true,
        animateOut: 'fadeOut'
    });

    var owlDetailGaleryNav = $('.owl-galery-nav');
    owlDetailGaleryNav.owlCarousel({
        loop: false,
        margin: 10,
        autoplay:false,
        nav: true,
        dots: true,
        navText: ['<i class="icon icon-next-2"><i>','<i class="icon icon-next-2"><i>'],
        responsive : {
            0 : {
                items: 1
            },
            400 : {
                items: 3
            },
            928 : {
                items: 5
            }
        }
    });

    owlDetailGalery.on('changed.owl.carousel', function(event) {
        var element = $('.detail-galery .item').eq(event.item.index);

        var t = $(element).attr('data-title');
        var b = $(element).attr('data-btn-title');
        var c = $(element).attr('data-btn-link');
        if(typeof t !== "undefined"){
            $('#subgalery-nav h1').html(t);
        }else{
            $('#subgalery-nav h1').html("");
        }

        if(typeof b !== "undefined"){
            btn = '<a href="'+c+'" class="btn red">'+b+'<i class="icon-arrow-right"></i></a>'
            $('#subgalery-nav .bt').html(btn);
        }else{
            $('#subgalery-nav .bt').html('');
        }
    })

    $('.owl-galery-nav .owl-item').click(function() {
        $('.detail-galery').trigger('to.owl.carousel', $(this).index());
    });


    var owlPhotos = $('.home-galery');
    owlPhotos.owlCarousel({
        loop: false,
        margin: 25,
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
        nav: true,
        dots: true,
        navText: ['<i class="icon icon-next-2"><i>','<i class="icon icon-next-2"><i>'],
        responsive : {
            0 : {
                items: 1
            },
            768 : {
                items: 2
            }
        }
    });



    $(function() {
      $('select').selectric();
    });

    renderMaps(renderMap);

    $('#filter select').on('selectric-change', function(event, element, selectric) {
        $('#filter').submit();
    });
});


function renderMaps(renderMap){
    if(renderMap == 1){
        var LeafIcon = L.Icon.extend({
            options: {
                iconSize:     [75, 100],
                iconAnchor:   [37, 100]
            }
        });
        var icons  = new LeafIcon({iconUrl: url+'/img/map.svg'});

        zoom = 10;
        if($('#map').attr('data-zoom') != '')  zoom = parseInt($('#map').attr('data-zoom'));
        lat  = parseFloat($('#map').attr('data-lat'));
        lng  = parseFloat($('#map').attr('data-lng'));

        lat2  = parseFloat($('#map').attr('data-lat2'));
        lng2  = parseFloat($('#map').attr('data-lng2'));

        var mbAttr = '',
            mbUrl = 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoicm9jZXNtYW5pYyIsImEiOiJjam5hb2NzazQyZWxoM2tydWd0OHN5OThkIn0.2kz8ZH1-HH-TkOh1anDHDA';

        //var grayscale   = L.tileLayer(mbUrl, {id: 'mapbox/light-v9', attribution: mbAttr});
        var grayscale = L.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png', {
        	maxZoom: 20,
        	attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
        });
        var map = L.map('map', {
            center: [49.7330133, 15.8018754],
            zoom: zoom,
            layers: [grayscale],
            scrollWheelZoom: false
        });

        L.marker([lat, lng], {icon: icons}).addTo(map);
        L.marker([lat2, lng2], {icon: icons}).addTo(map);
    }
}
